import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Update orchid pro
 * will return in UserInfo
 */
export default async function postOrchidProCompleteSchedulerTutorial() {
  const res = await fetchOrchidAPI(
    "/api/users/v1/orchid_pro/complete_scheduler_tutorial",
    {
      method: "POST",
    },
  );
  if (!res.ok) {
    throw new Error(
      `failed to post complete schedule tutorial: ${getErrorDetail(
        await res.text(),
      )}`,
    );
  }

  return;
}
